var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpvotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06891 4.66725C7.33724 3.83483 7.47316 3.10625 7.47316 2.478C7.47316 1.07858 6.92541 0 6.01482 0C5.52074 0 5.36791 0.294583 5.17657 1.01908C5.18649 0.981167 5.08149 1.38892 5.05116 1.498C4.99224 1.708 4.88957 2.06383 4.74374 2.56608C4.73978 2.5795 4.73388 2.59228 4.72624 2.604L3.05441 5.22083C2.65881 5.83985 2.07507 6.31563 1.38899 6.57825L0.655739 6.85883C0.431502 6.94471 0.244713 7.10688 0.12821 7.31685C0.0117062 7.52681 -0.0270555 7.77112 0.0187386 8.00683L0.418905 10.0707C0.466644 10.3169 0.583934 10.5443 0.75689 10.7259C0.929847 10.9076 1.15123 11.0358 1.39482 11.0956L6.20732 12.2751C6.9167 12.4489 7.66601 12.3356 8.29228 11.9598C8.91855 11.584 9.37112 10.9761 9.55157 10.2684L10.4697 6.6675C10.5301 6.43067 10.5355 6.18318 10.4856 5.94393C10.4357 5.70467 10.3318 5.47999 10.1818 5.28701C10.0319 5.09404 9.83979 4.93789 9.62026 4.83048C9.40072 4.72307 9.15955 4.66724 8.91516 4.66725H7.06891Z",
    fill: "#0071A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvotes);
export default __webpack_public_path__ + "static/media/upvotes.6c8ebaf660cb2de8d3993689262b4169.svg";
export { ForwardRef as ReactComponent };